<template>

  <nav class="flex items-center justify-between flex-wrap bg-blue-100 p-6">

    <!-- <div class="block mx-auto mt-4 md:hidden">
    <button @click="showmenu = !showmenu" class="flex items-center px-3 py-2 border rounded text-blue-800 text-2xl">
    <i class="fas fa-bars"> </i>
  </button>
</div> -->

<!-- DESKTOP MENU -->
<div class="hidden w-full md:block flex-grow md:flex md:items-center md:w-auto text-left" >

  <div class="text-xl  md:flex-grow">

    <router-link :to="'/'" class="block mt-4 md:inline-block md:mt-0 text-blue-800 hover:text-blue-800 mr-12" :class="{currentnav: this.$route.params.url == undefined}">

      Über den Verein

    </router-link>


    <router-link :to="'../verein/news'" class="text-blue-800 hover:text-blue-800 mr-12" :class="{currentnav: this.$route.params.url == 'news'}">

      News & Veranstaltungen

    </router-link>

    <!-- <router-link :to="'../verein/veranstaltungen'" class=" text-blue-800 hover:text-blue-800 mr-12" :class="{currentnav: this.$route.params.url == 'veranstaltungen'}">

      Vergangene Veranstaltungen

    </router-link> -->

    <router-link :to="'../verein/galerie'" class=" text-blue-800 hover:text-blue-800 mr-12" :class="{currentnav: this.$route.params.url == 'galerie'}">

      Bildergalerien

    </router-link>

    <!-- <router-link :to="'../verein/archiv'" class=" text-blue-800 hover:text-blue-800 mr-12" :class="{currentnav: this.$route.params.url == 'archiv'}">

      Archiv

    </router-link> -->

    <router-link :to="'../verein/kontakt'" class=" text-blue-800 hover:text-blue-800 mr-12" :class="{currentnav: this.$route.params.url == 'kontakt'}">

      Kontakt

    </router-link>

    <router-link :to="'../verein/mitglied'" class=" text-blue-800 hover:text-blue-800 mr-12" :class="{currentnav: this.$route.params.url == 'mitglied'}">

      Mitglied werden

    </router-link>

  </div>

</div>

</nav>

</template>

<script>
export default {
  components: {

  },
  name: 'VereinAbout',
  props: {

  },
  data() {
    return {

    }
  },
  methods: {

    getroute(){
      // console.log(this.$route.params.url);
    },


  },
  mounted: function(){
    this.getroute();
  },

  computed: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.currentnav {

  border-bottom: 2px solid #2A4867;

}

</style>
